import { useEffect } from "react";
import { Card, Tabs } from "antd";
import { BgColorsOutlined, SettingOutlined } from "@ant-design/icons";
import { t } from "i18next";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import AppConfig from "../../core/service/AppConfig";
import { PERMISSIONS, useUser } from "../../core/context/UserContext";
import BrandingPanel from "./BrandingPanel";
import ConfigPanel from "./ConfigPanel";

/**
 * Yönetim paneli — sekmeli.
 *
 * Her sekme KENDİ izniyle görünür: marka logosu yüklemek ile sunucunun yapılandırmasını değiştirmek
 * aynı yetki seviyesinde değildir (BRANDING_MANAGE vs CONFIG_MANAGE).
 */
export default function SettingsPage()
{
    const { hasPermission } = useUser();

    useEffect(() => {
        document.title = `${t("Settings")} | ${AppConfig.getRisTitle()}`;
    }, []);

    const tabs = [];

    if (hasPermission(PERMISSIONS.BRANDING_MANAGE)) {
        tabs.push({
            key: "branding",
            label: <span><BgColorsOutlined /> {t("Branding")}</span>,
            children: <BrandingPanel />,
        });
    }

    if (hasPermission(PERMISSIONS.CONFIG_MANAGE)) {
        tabs.push({
            key: "config",
            label: <span><SettingOutlined /> {t("Configuration")}</span>,
            children: <ConfigPanel />,
        });
    }

    return (
        <LayoutWithSider sidebarTitle={t("Settings")} fullWidth>
            <Card title={t("Settings")} className="settings-card">
                <Tabs items={tabs} destroyInactiveTabPane={false} />
            </Card>
        </LayoutWithSider>
    );
}
